export default __webpack_public_path__ + "static/media/closeIcon.7b4d8ecf.svg";